/**
 * mindmap/conversationApi.js — Sprint 1 refactor (2026-05-20)
 *
 * Trước: REACT_APP_OPENAI_KEY + user_token query param + /stream.
 * Sau:   gateway POST /api/v1/llm-gateway/chat/stream với JWT, tool='mindmap'.
 *
 * Backend routing → Claude Sonnet 4.6 (structured output cho mind map).
 */

import { streamChatLegacy, RateLimitError } from '../_shared/llmGateway';
import { authManager } from 'utils/authManager';

const apiHost = process.env.REACT_APP_API_URL || '/api/v1';
const TOOL = 'mindmap';

const MINDMAP_SYSTEM_PROMPT =
    'Bạn là trợ lý sinh sơ đồ tư duy (mind map). Trả lời dạng markdown nested list, root ở dòng đầu, các nhánh dùng dấu "-" thụt lề 2 spaces.';

export async function fetchAnswerApi(question, _apiKey, selectedDocs, history = [], conversationId) {
    const auth = authManager.getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (auth) headers.Authorization = `Bearer ${auth}`;

    const cleanHistory = history.map((item) => ({ prompt: item.prompt, response: item.response }));

    const res = await fetch(`${apiHost}/answer/mindmap`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
            question,
            history: cleanHistory,
            selected_docs: selectedDocs,
            conversation_id: conversationId,
            project: TOOL,
        }),
    });
    if (!res.ok) throw new Error(res.statusText || 'fetchAnswerApi failed');
    const data = await res.json();
    return {
        answer: data.answer,
        query: question,
        result: data.answer,
        sources: data.sources,
        conversationId: data.conversation_id,
    };
}

/**
 * Streaming mind-map qua LLM Gateway.
 * Chữ ký cũ: (question, apiKey, selectedDocs, history, conversationId, onEvent)
 */
export function fetchAnswerSteaming(
    question,
    _apiKey,
    _selectedDocs,
    history = [],
    _conversationId,
    onEvent,
    opts = {}
) {
    return streamChatLegacy({
        tool: TOOL,
        question,
        history,
        systemPrompt: opts.systemPrompt || MINDMAP_SYSTEM_PROMPT,
        signal: opts.signal,
        onEvent,
    }).catch((e) => {
        if (e instanceof RateLimitError) {
            onEvent?.(new MessageEvent('message', { data: JSON.stringify({ type: 'error', detail: e.message, tool: TOOL, status: 429 }) }));
        }
        throw e;
    });
}

export async function sendFeedback(prompt, response, feedback) {
    const auth = authManager.getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (auth) headers.Authorization = `Bearer ${auth}`;
    const res = await fetch(`${apiHost}/feedback`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ question: prompt, answer: response, feedback, project: TOOL }),
    });
    if (!res.ok) throw new Error('sendFeedback failed');
}
